import React, { Component } from 'react';
const products = [{
  name: 'CHMER RV853L High Precision Wire EDM',
  image: 'https://i.machineryhost.com/4a716f7ba05468f225127f29aa2040c5/edd6ec83512c61756f6603c2c66bac8f/large-image-cHJvZHVjdA_--c168655235707702300.jpg',
  href: '/listings/4831851-chmer-rv853l-high-precision-wire-edm'
}, {
  name: 'CHMER RV855L High Precision Wire EDM',
  image: 'https://i.machineryhost.com/4a716f7ba05468f225127f29aa2040c5/6052832603544761aef12c4ad2edddd9/large-image-cHJvZHVjdA_--c168655237124956200.jpg',
  href: '/listings/4831850-chmer-rv855l-high-precision-wire-edm'
}, {
  name: 'CHMER RV1065L High Precision Wire EDM',
  image: 'https://i.machineryhost.com/4a716f7ba05468f225127f29aa2040c5/b4f3657b20d563801560f4d41b2d6384/large-image-cHJvZHVjdA_--c168655242200316900.jpg',
  href: '/listings/4831853-chmer-rv1065l-high-precision-wire-edm'
}, {
  name: 'CHMER RV1285L High Precision Wire EDM',
  image: 'https://i.machineryhost.com/4a716f7ba05468f225127f29aa2040c5/cb6f354b6fd9360c951099bf71956da1/large-image-cHJvZHVjdA_--c168655245767058300.jpg',
  href: '/listings/4831860-chmer-rv1285l-high-precision-wire-edm'
}];
export function RVSeriesSection() {
  return <section data-id="element-2051">
      <div className="bg-[#1874cd] py-4 px-6 rounded-t-xl" data-id="element-2052">
        <h2 className="text-xl md:text-2xl font-bold text-white" data-id="element-2053">
          CHMER RV Series - Linear Motor, Large Travel Gantry Style
        </h2>
      </div>
      <div className="bg-white p-6 md:p-8 rounded-b-xl shadow-sm border border-gray-200 border-t-0" data-id="element-2054">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6" data-id="element-2055">
          {products.map((product, pIndex) => <div key={pIndex} className="group bg-white rounded-xl shadow-md border border-gray-100 overflow-hidden hover:shadow-xl hover:-translate-y-1 transition-all duration-300 flex flex-col h-full" data-id="element-2056">
              <a href="/m7_view_item.html" className="bg-gray-50 p-6 h-56 flex items-center justify-center border-b border-gray-100 block" data-id="element-2057">
                <img src={product.image} alt={product.name} className="max-w-full max-h-full object-contain group-hover:scale-105 transition-transform duration-500 block" data-id="element-2058" />
              </a>
              <div className="p-5 flex flex-col flex-grow" data-id="element-2059">
                <a href="/m7_view_item.html" className="no-underline" data-id="element-2060">
                  <h3 className="text-base font-bold text-navy mb-4 leading-tight group-hover:text-orange transition-colors" data-id="element-2061">
                    {product.name}
                  </h3>
                </a>
                <div className="mt-auto pt-4 border-t border-gray-100 flex flex-col space-y-2" data-id="element-2062">
                  <a href={`/ContactPeakMachineSales.html?i515589:default[Product%20Title]=${encodeURIComponent(product.name)}`} className="inline-flex items-center justify-center w-full bg-navy text-white px-4 py-2 rounded-md font-bold text-sm hover:bg-orange transition-colors no-underline" data-id="element-2063">
                    Request for Quote
                  </a>
                  <a href="/m7_view_item.html" className="inline-flex items-center justify-center w-full bg-gray-100 text-navy px-4 py-2 rounded-md font-bold text-sm hover:bg-gray-200 transition-colors no-underline" data-id="element-2064">
                    More Information
                  </a>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}